import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { LendingReturnPackageVolumeWeekdayHeatmapChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { weekdayHeatmapWindow } from '../../../analytics/insights/insight-detail/insight-heatmap-window';
import { useInsightFetchRange } from '../../../analytics/insights/insight-detail/use-insight-fetch-range';
import { getLast6MonthsChartRange } from '../../pudo/last-30-days-chart-range';
import { Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChartProps } from './last-6-months-lending-return-package-volume-weekday-heatmap-chart.component';

export const useLast6MonthsLendingReturnPackageVolumeWeekdayHeatmapChart = (props: Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [rangeStart, setRangeStart] = useState<string | undefined>(undefined);
    const [weekCount, setWeekCount] = useState<number | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getLast6MonthsChartRange);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = fetchRange;
        const heatmapWindow = weekdayHeatmapWindow(after, before);
        setRangeStart(heatmapWindow.rangeStart);
        setWeekCount(heatmapWindow.weekCount);

        ChartClient.fetchChartData(props.accountId, LendingReturnPackageVolumeWeekdayHeatmapChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            ...fetchRange.entityParams
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId, fetchRange.key]);

    return {
        data,
        isLoading,
        rangeStart,
        weekCount
    };
};
